import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';
import { IPublicAccountPagedRequest } from '../../../../model/apm/public-account/request/public-account-paged-request';
import { IPublicAccountAddEditRequest } from '../../../../model/apm/public-account/request/public-account-add-edit-request';
import { IPublicAccountListResponse } from '../../../../model/apm/public-account/response/public-account-list-response';
import { IPublicAccountResponse } from '../../../../model/apm/public-account/response/public-account-response';
import { IPublicAccountCategoryResponse } from '../../../../model/apm/public-account/response/public-account-category-response';

const defaultPath = 'PublicAccount';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IPublicAccountPagedRequest): Promise<Pagination<IPublicAccountListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            CategoryId: params.categoryId,
            SubcategoryId: params.subcategoryId,
            Year: params.year,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IPublicAccountListResponse>(), response.data));
};

const listCategories = async (): Promise<IPublicAccountCategoryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Category`
    }).then((response) => response.data || []);
};

const listDocumentTypes = async (): Promise<ILookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentType`
    }).then((response) => response.data || []);
};

const getById = async (id: number): Promise<IPublicAccountResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IPublicAccountAddEditRequest): Promise<IPublicAccountResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IPublicAccountAddEditRequest): Promise<IPublicAccountResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

// O Content-Type multipart (com boundary) é definido pelo axios a partir do FormData
const uploadFile = async (id: number, documentTypeId: number, file: File, onProgress?: (percent: number) => void): Promise<IPortalDocumentResponse> => {
    const formData = new FormData();
    formData.append('DocumentTypeId', String(documentTypeId));
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/File`,
        data: formData,
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(Math.round((event.loaded * 100) / event.total));
            }
        }
    }).then((response) => response.data);
};

const removeFile = async (id: number, fileId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/File/${fileId}`
    });
};

const PublicAccountAppService = {
    list, getById, add, edit, remove,
    listCategories, listDocumentTypes, uploadFile, removeFile
};
export default PublicAccountAppService;
